import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import React from 'react';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { formatDate } from '@/lib/formatUtils';
import { useReportContext } from '../context';

interface Props {
  onSearchClick: () => void;
  onRefreshClick: (getReport: (params: MuaHangRecord) => Promise<void>) => void;
  onFixedColumnsClick: () => void;
  onExportDataClick: () => void;
  onPrintClick: () => void;
  onEditPrintTemplateClick: () => void;
  fromDate?: string | Date;
  toDate?: string | Date;
  className?: string;
  getReport: (params: MuaHangRecord) => Promise<void>;
}

export function ActionBar({
  onSearchClick,
  onRefreshClick,
  onFixedColumnsClick,
  onExportDataClick,
  onPrintClick,
  onEditPrintTemplateClick,
  fromDate,
  toDate,
  className,
  getReport
}: Props) {
  // Create date range display
  const getDateRangeDisplay = () => {
    if (!fromDate || !toDate) return '';

    const formattedFromDate = formatDate(fromDate);
    const formattedToDate = formatDate(toDate);

    if (formattedFromDate && formattedToDate) {
      return `Từ ngày ${formattedFromDate} đến ngày ${formattedToDate}`;
    }

    return '';
  };

  const dateRangeText = getDateRangeDisplay();
  const { canExport } = useReportContext();
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div className='flex flex-col'>
          <h1 className='text-xl font-bold'>Báo cáo mua hàng nhóm theo 2 chỉ tiêu</h1>
          {dateRangeText && (
            <p className='mt-1 text-[11px] text-gray-600'>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              {dateRangeText}
            </p>
          )}
        </div>
      }
    >
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} variant='primary' />
      <ActionButtonV2
        icon={RefreshCircle1ClockwiseStroke}
        title='Làm mới'
        variant='destructive'
        onClick={() => onRefreshClick(getReport)}
      />
      <ActionButtonV2 icon={SignPostLeftStroke} title='Cố định cột' onClick={onFixedColumnsClick} />
      <ActionButtonV2 icon={Download1Stroke} title='Xuất dữ liệu' onClick={onExportDataClick} disabled={!canExport} />
      <ActionButtonV2 icon={PrinterStroke} title='In' onClick={onPrintClick} />
      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
}
